import { useFormik } from "formik";
import { useCallback, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import DatePicker from 'react-date-picker';
import { useQueryClient } from "react-query";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { GetEstadosEntregaCarta } from "../../../../api/Api";
import ConfirmWithLoader from "../../../../Components/Modals/ConfirmWithLoader";
import './EntregaCartaModal.css';

export default function EntregaCartaModal({
  showModal = false,
  setShowModal,
  isFinishSave = false,
  onConfirm,
  onClose,
  messageError,
  title,
  value
}) {

  const [isLoadingSave, setIsLoadingSave] = useState(true);

  const [estadosOptions, setEstadosOptions] = useState([]);

  const queryClient = useQueryClient();

  const { values: formikValues,
    setFieldValue: setFormikFieldValue,
    handleSubmit: handleSubmitFormik } = useFormik({
      initialValues: {
        fechaLimite: value?.fechaLimite || null,
        estado: value?.estado?.value ? value.estado : null
      },
      enableReinitialize: true,
      onSubmit: (values) => {
        setIsLoadingSave(true);
        onConfirm && onConfirm(values);
      }
    })

  useEffect(() => {
    if (showModal) {
      queryClient.fetchQuery('getEstadosEntregaCarta', GetEstadosEntregaCarta).then((result) => {
        if (result.success) {
          const options = result.data.map(item => ({
            value: item.codigo,
            label: item.nombre
          }));
          setEstadosOptions(options);
        }

      }).catch((err) => {
      }).finally(() => {
        setIsLoadingSave(false);
      });
    }
  }, [showModal, queryClient])


  const validateButtonConfirm = useCallback(() => {
    return !(formikValues.fechaLimite && formikValues.estado)
  }, [formikValues.estado, formikValues.fechaLimite])

  const handleClose = useCallback(() => {
    setIsLoadingSave(true);
    onClose && onClose();
  }, [onClose])

  useEffect(() => {
    if (isFinishSave) {
      setIsLoadingSave(false);
    }
  }, [isFinishSave])


  return (
    <>
      <ConfirmWithLoader
        showModal={showModal}
        setShowModal={setShowModal}
        title={title}
        isLoading={isLoadingSave}
        isFinish={isFinishSave}
        disabledConfirmButton={validateButtonConfirm()}
        hideContentInLoading={false}
        hideActionAfterConfirm={false}
        textButtonCancel={"Cerrar"}
        textButton={"Guardar"}
        onConfirm={() => handleSubmitFormik()}
        onClose={handleClose}
      >
        {!isLoadingSave && isFinishSave && (
          messageError ? (
            <Alert key='error' variant='primary' className='mb-8'>
              <b>Error</b>: {messageError}
            </Alert>
          ) : (
            <Alert key='info' variant='success' className='mb-8'>
              <b>Entrega de Carta Guardada</b>: La entrega de Carta se ha guardado exitosamente.
            </Alert>
          )
        )}
        <div className="container">
          <div className="row">
            <div className="col-12 d-flex align-items-center">
              <label className="fw-bold fs-6 me-4 label-form-entrega-carta text-end">Fecha de entrega:</label>
              <DatePicker
                className="form-control form-control-solid flex-grow-1 w-auto"
                locale="es"
                value={formikValues.fechaLimite}
                dateFormat="dd/MM/yyyy"
                shouldCloseOnSelect={false}
                onChange={(date) => setFormikFieldValue(`fechaLimite`, date)}
              />

            </div>
            <div className="col-12 d-flex align-items-center mt-5">
              <label className="fw-bold fs-6 me-4 label-form-entrega-carta text-end">Estado:</label>
              <Select
                classNamePrefix='filter'
                components={makeAnimated()}
                value={formikValues.estado}
                options={estadosOptions}
                isMulti={false}
                closeMenuOnSelect={true}
                placeholder="Selecciona"
                className="flex-grow-1 w-auto"
                isSearchable={false}
                onChange={(value) => { setFormikFieldValue(`estado`, value) }}
              />
            </div>
          </div>
        </div>




      </ConfirmWithLoader>
    </>
  )
}